module.exports = __webpack_public_path__ + "img/date-3.ca1b72f2.svg";